import axios, { type AxiosInstance } from 'axios';
import { apiConfig } from '@/config/api';

export const validationApi: AxiosInstance = axios.create({
  baseURL: apiConfig.validatorBaseUrl,
  timeout: apiConfig.timeout,
});
